import {
  IBaseProjectPosition,
  ICreateProjectPosition,
  IProjectPosition,
  IProjectPositionStringSkills
} from '../../../../interfaces/projectPosition';
import UpdatePosition from './UpdatePosition';
import CreatePosition from './CreatePosition';
import { ILanguageCode } from '../../../../interfaces/languageCode';
import { IPositionWithSkills } from '../../../../interfaces/position';
import { createContext, useState } from 'react';
import { useGetPositionsWithSkills } from '../../../../queryHooks/useGetPositionsWithSkills';
import { useGetLanguageCodes } from '../../../../queryHooks/useGetLanguageCodes';
import { Navigate } from 'react-router-dom';
import { HOME_PATH } from '../../../../router/paths';

export interface IPositionEntityModalProps {
  positionEntity?: IProjectPosition | IProjectPositionStringSkills,
  refreshPositions: () => void,
  onClose: () => void,
  handleAddNewPosition?: (position: ICreateProjectPosition) => Promise<IProjectPosition>;
  handleUpdatePosition: (positionId: string, position: IBaseProjectPosition) => Promise<IProjectPosition>;
  handleAddNewSkillsToPosition: (positionId: string, skills: string[]) => Promise<IProjectPosition>;
  handleRemoveSkillsFromPosition: (positionId: string, skills: string[]) => Promise<IProjectPosition>;
}

interface IPositionModalContext extends Omit<IPositionEntityModalProps, 'positionEntity'> {
  languageCodes: ILanguageCode[],
  positionsWithSkills: IPositionWithSkills[]
}

export const PositionModalContext = createContext<IPositionModalContext>({} as IPositionModalContext);

const PositionEntityModal = ({ positionEntity, ...props }: IPositionEntityModalProps) => {
  const [languageCodes, setLanguageCodes] = useState<ILanguageCode[]>([]);
  const [positionsWithSkills, setPositionsWithSkills] = useState<IPositionWithSkills[]>([]);
  const { data: skills } = useGetPositionsWithSkills({ onSuccess: (data) => setPositionsWithSkills(data) });
  const { data: codes } = useGetLanguageCodes({ onSuccess: (data) => setLanguageCodes(data) });

  return (
    <PositionModalContext.Provider
      value={{ languageCodes: codes || languageCodes, positionsWithSkills: skills || positionsWithSkills, ...props }}>
      {
        positionEntity
          ? <UpdatePosition positionEntity={positionEntity}/>
          : !!props.handleAddNewPosition ? <CreatePosition/> : <Navigate to={HOME_PATH}/>
      }
    </PositionModalContext.Provider>
  );
};

export default PositionEntityModal;